import EA from 'helpers/init';
import gsap from 'gsap';

export default EA.Methods.customCursor = ($this) => {
    const cursorArea = $this.querySelector('.cursor-area');
    const triggers = $this.querySelectorAll('.cursor-trigger');
    const cursor = $this.querySelector('.custom-cursor');
    const mq = window.matchMedia('(min-width: 1001px)');

    triggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => {
            if (mq.matches) {
                cursor.classList.add('visible');
            }
        });
    });

    triggers.forEach((trigger) => {
        trigger.addEventListener('mouseleave', () => {
            cursor.classList.remove('visible');
        });
    });

    const customCursor = () => {
        if (mq.matches) {
            gsap.set(cursor, { xPercent: -50, yPercent: -50 });

            const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
            const mouse = { x: pos.x, y: pos.y };
            const speed = 0.1;

            const xSet = gsap.quickSetter(cursor, 'x', 'px');
            const ySet = gsap.quickSetter(cursor, 'y', 'px');

            cursorArea.addEventListener('mousemove', e => {
                mouse.x = e.x;
                mouse.y = e.y;
            });

            gsap.ticker.add(() => {
                const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

                pos.x += (mouse.x - pos.x) * dt;
                pos.y += (mouse.y - pos.y) * dt;
                xSet(pos.x);
                ySet(pos.y);
            });
        }
    };

    window.addEventListener('load', customCursor);
    window.addEventListener('resize', customCursor);
};
